const splitSpaceCode = (code: string) => {
  const MIN_LENGTH_TO_SPLIT_SPACE_CODE = 40
  const MAX_LENGHT_TO_SPLIT_SPACE_CODE = 60
  const newCode = code.split('')
  if (
    code.length < MAX_LENGHT_TO_SPLIT_SPACE_CODE &&
    code.length > MIN_LENGTH_TO_SPLIT_SPACE_CODE
  ) {
    const splitCount = -code.length / 2
    const partOne = newCode.splice(splitCount).join('')
    const partTwo = newCode.join('')
    return [partOne, partTwo]
  } else if (newCode.length > MAX_LENGHT_TO_SPLIT_SPACE_CODE) {
    const splitCount = -code.length / 3
    const partOne = newCode.splice(splitCount).join('')
    const partTwo = newCode.splice(splitCount).join('')
    const partThree = newCode.join('')
    return [partOne, partTwo, partThree]
  } else {
    return [newCode.join('')]
  }
}
export default splitSpaceCode
